// 常用正则

// email url hex 从 async-validator 中复制的，async-validator 并没有导出这些值
// http://emailregex.com/
export let email = () => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export let url = () => new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i')
export let hex = () => /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
export let phone = () => /^1(3\d|4[57]|5[0-35-9]|7[0135678]|8\d)\d{8}$/
// 学号
export let student_number = () => /^\d{3,10}$/
export let qq = () => /^[1-9][0-9]{2,15}$/
export let zip_code = () => /^\d{6}$/
export let digits = () => /^\d*$/
// 英文单词
export let english = () => /^[a-z]*$/i
export let ascii = () => /^[\x20-\x7F]*$/i
// 若干中文字
export let chinese = () => /^[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFF]+$/i
// 中英文姓名
export let name = () => /^[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFFa-z'\-,\.& \(\)\d]+$/i
// 身份证号
// \d{6} 省市区各2位
// \d{8} 年月日
// \d{3} 顺序位
// \d|X 校验位
export let id_number = () => /^(\d{6})(\d{8})(\d{3})(\d|X)$/i
// 日期
export let date = () => /^(\d{4})(\d{2})(\d{2})$/
// 年
export let year = () => /^\d{4}$/

export let image_type = () => /\.(gif|png|jpe?g|tiff?)$/i

export let audio_type = () => /\.(mp3|wav|ogg|raw|3gp|aa|aac|aax|m4a)$/i

export let video_type = () => /\.(wkv|flv|f4v|avi|mov|wmv|rm|rmvb|amv|mp4|m4p|m4v|mpeg)$/i

export let archive_type = () => /\.(zip|rar|tar|7z|jar|iso|xar|xz)$/i

export let pdf_type = () => /\.pdf$/i

export let ppt_type = () => /\.(pot|pps|ppsx|ppsm|potx|potm|ppt|pptx|pptm|sldx|sldm)$/i

export let word_type = () => /\.(doc|docx|docm|docb|dotx|dotm)$/i

export let excel_type = () => /\.(csv|xls|xlt|xlm|xlsx|xlsm|xltx|xltm|xlsb|xla|xlw)$/i

export let text_type = () => /\.te?xt$/i



// WEBPACK FOOTER //
// ./src/utils/regexp.js